import {environment} from '../../../environments/environment';

export class Region {
  constructor(public domain = environment.baseURL, public name = 'default') {
  }
}
